import type { TableSelectedCell } from '@/components/custom/erp/input-table-v2';
import { useTableRows } from '@/components/custom/erp/input-table-v2';
import type { FormFieldState } from './useFormFieldState';

export type SelectedCellInfo = TableSelectedCell;

export function useDetailRows<
  T extends {
    uuid: string;
    line?: number;
  }
>(
  initialRows: T[] = [],
  onChange?: (rows: T[]) => void,
  onFieldValueChange?: (row: T, field: string, value: BanHangValue) => Partial<T>,
  _formState?: FormFieldState
) {
  const handleFieldValueChange = (row: T, field: string, value: BanHangValue): Partial<T> => {
    const externalUpdates = onFieldValueChange?.(row, field, value) || {};

    return {
      ...externalUpdates
    };
  };

  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handleMoveRow,
    handlePasteRow,
    setNonWritableFields,
    setPasteConfigs
  } = useTableRows<T>({
    initialRows,
    defaultRows: 1,
    onChange,
    onFieldValueChange: handleFieldValueChange,
    defaultField: 'ma_vt'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs
  };
}
